import { useEffect, useState } from "react";
import MultiCheckSelect from "../../option-select/MultiCheckSelect";
import { reactSelectTheme } from "../../option-select/reactSelectTheme";
import { searchWithFilters, createListQuery } from "../../../services/api/search";

interface WorkorderOriginSelectProps {
    value?: any,
    onChange?: (values: any) => void,
    disabled?: boolean
}

/**
* WorkorderOriginSelect: Select workorder origin component
* Used to select workorder origins for filtering
* @param value - Selected values
* @param onChange - On change callback
* @param disabled - Disabled state
*/
const WorkorderOriginSelect = (props: WorkorderOriginSelectProps) => {
  const [workorderOriginListState, setWorkorderOriginListState] = useState<any[]>([]);
  const [valueState, setValueState] = useState<any>(null);

  useEffect(() => {
    // Récupérer la liste des origines de workorder depuis l'API
    searchWithFilters<EasyTech.WorkorderOrigin>("workorder_origins", {
      queries: [createListQuery("enabled", [true, false], "IN")]
    }, true, false)
      .then((response) => {
        const origins = response.data as EasyTech.WorkorderOrigin[];
        const options = origins
          .filter(origin => origin.enabled) // Filtrer seulement les origines activées
          .map((origin) => ({
            value: origin.id,
            label: origin.label
          }));
        setWorkorderOriginListState(options);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des origines de workorder:", error);
        setWorkorderOriginListState([]);
      });
  }, []);

  useEffect(() => {
    if (props.value) {
      if (Array.isArray(props.value)) {
        setValueState(props.value.map((val: any) => {
          const origin = typeof val === "string" ? val : val.id;
          const option = workorderOriginListState.find(opt => opt.value === origin);
          return option || { value: origin, label: origin };
        }));
      } else {
        const origin = typeof props.value === "string" ? props.value : props.value.id;
        const option = workorderOriginListState.find(opt => opt.value === origin);
        setValueState(option || { value: origin, label: origin });
      }
    } else {
      setValueState(null);
    }
  }, [props.value, workorderOriginListState]);

  const workorderOriginChange = ((value: any) => {
    setValueState(value);
    if (props.onChange) {
      if (Array.isArray(value)) {
        props.onChange(value.map((val: {value: string, label: string}) => val.value));
      } else if (value) {
        props.onChange(value.value);
      } else {
        props.onChange(null);
      }
    }
  });

  return (
    <div className="flex w-full min-w-0">
      <MultiCheckSelect options={workorderOriginListState}
        value={valueState}
        theme={reactSelectTheme}
        onChange={workorderOriginChange}
        name="workorderOrigin"
        placeholder="Sélectionner une origine d'intervention"
        className="min-w-0 w-full"
        classNamePrefix="react-select"
        isDisabled={props.disabled} />
    </div>
  );
};

export default WorkorderOriginSelect;